import { render } from "./VSponsor.vue?vue&type=template&id=9e623d54"
import script from "./VSponsor.vue?vue&type=script&lang=ts"
export * from "./VSponsor.vue?vue&type=script&lang=ts"

import "./VSponsor.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script